/* Tema (light/dark) — classe `dark` no <html> + persistência em localStorage. */
import { useEffect, useState } from "react";

const KEY = "zemo-theme";

export function getTheme() {
  try {
    return localStorage.getItem(KEY) || "light";
  } catch {
    return "light";
  }
}

function applyTheme(theme) {
  document.documentElement.classList.toggle("dark", theme === "dark");
}

export function setTheme(theme) {
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* storage indisponível — aplica só em memória */
  }
  applyTheme(theme);
  window.dispatchEvent(new Event("zemo-theme-change"));
}

export function toggleTheme() {
  const next = getTheme() === "dark" ? "light" : "dark";
  setTheme(next);
  return next;
}

export function initTheme() {
  applyTheme(getTheme());
}

export function useTheme() {
  const [theme, set] = useState(getTheme());
  useEffect(() => {
    const sync = () => set(getTheme());
    window.addEventListener("zemo-theme-change", sync);
    return () => window.removeEventListener("zemo-theme-change", sync);
  }, []);
  return [theme, setTheme];
}
